/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'star-gray': {
    width: 512,
    height: 512,
    viewBox: '0 0 512.07 512.07',
    data: '<g _fill="#ccc"><path pid="0" d="M509.759 194.639c-6.152-18.858-22.945-31.043-42.781-31.043H339.06l-40.282-122.33c-6.192-18.805-22.95-30.926-42.729-30.926-.013 0-60.013 203.372-60.013 203.372l60 203.372 103.827 75.824c16.061 11.728 36.843 11.766 52.945.096 16.103-11.669 22.537-31.43 16.392-50.343L389.508 320.5h.535l103.474-75.563c16.019-11.697 22.395-31.441 16.242-50.298z"/><path pid="1" d="M255.858 10.341c-19.86.078-36.611 12.349-42.674 31.262l-39.108 121.993H45.093c-19.886 0-36.692 12.226-42.814 31.146-6.123 18.92.335 38.674 16.453 50.324l103.929 75.121L82.867 442.66c-6.145 18.913.289 38.674 16.392 50.343 16.102 11.669 36.885 11.632 52.945-.096l103.83-75.825c.002.002.002-406.742.002-406.742l-.178.001z"/></g>'
  }
})
